import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CustomButtonProps } from "../../interfaces/Common";

export const AppButton = styled(Button)<CustomButtonProps>(
  ({ theme, others, background, border }) => ({
    textTransform: "capitalize",
    boxShadow: "none !important",
    backgroundColor: background || 'transparent',
    color: others?.color || theme.palette.KenColors.kenWhite,

    "&:hover": {
      backgroundColor: background ? background : '#2C60AA',  // Use background or fallback
      color: others?.color || theme.palette.KenColors.kenWhite,
      border: border,
    },

    ...others,
  })
);
